import React, { useCallback, useEffect, useState } from "react";

// TYPESCRIPT

import { Hotspot, Popup, TourData } from "../../../Types";

// STATE MANAGEMENT

import {
  useAssetListStore,
  useCurrentSceneStore,
  useEditingElementStore,
  useTourDataStore,
  useWidePopupStore,
} from "../../../api/Zustand.ts";

// ICONS

import LinkInputIcon from "../../Icons/LinkInputIcon";
import PopupExpIcon from "../../Icons/PopupExpIcon";

// QUERIES

import { useQueryClient } from "@tanstack/react-query";
import { UseAssetsQuery, UseSaveTour } from "../../../api/calls/Queries.ts";
import { useGptHistoryStore } from "../../../api/calls/OpenAi.ts";

// GUI

import FileSelectorButton from "../GuiElements/FileSelectorButton.tsx";
import SceneDelConfirmPanel from "../SceneDelConfirmPanel.tsx";
import OtherHotspots from "./OtherHotspots.tsx";
import { EditPencil, Trashbin } from "../../Icons/gui-elements-icons.tsx";
import { OPENAIENABLED } from "../../../App.tsx";
import { getLanguageFile } from "../../common/GetLanguageFile.ts";

// import * as THREE from "three";

function PopupEditing(props: { id: any; tourID: number }) {
  const { id, tourID } = props;
  const { currentSceneID } = useCurrentSceneStore();

  const { data: images } = UseAssetsQuery(tourID, 2);

  const [currentPop, setCurrentPop] = useState<Hotspot>();
  const [currentPopContent, setCurrentPopContent] = useState<Popup>();

  const { tourData } = useTourDataStore();

  const { mutateAsync: saveTourData, isPending: isSavingTour } = UseSaveTour();

  const queryClient = useQueryClient();

  const { setEditingElem } = useEditingElementStore();

  // const { register, handleSubmit, reset, watch, setValue } = useForm({
  //   defaultValues: React.useMemo(() => {
  //     return { ...currentPop, content: currentPopContent };
  //   }, [currentPop, currentPopContent]),
  // });

  //

  //
  // React.useEffect(() => {
  //   reset({ ...currentPop, content: currentPopContent });
  // }, [currentPop, currentPopContent, reset]);
  //
  //
  // HOOK FORM
  //
  //
  // const onSubmit = handleSubmit(
  //   React.useCallback(
  //     (data) => {
  //       let popData = data;
  //       let popContentData = data.content;

  //       delete popData.content;

  //       const newTourData = queryClient.setQueryData(["GetTour", tourID], {
  //         ...tourData,

  //         scenes: tourData?.scenes.map((sc) =>
  //           sc.id === currentSceneID
  //             ? {
  //                 ...sc,
  //                 hotspots: sc.hotspots.map((hs: Hotspot) =>
  //                   hs.id === id
  //                     ? {
  //                         ...popData,
  //                         target: popContentData!.id,
  //                         EDIT_POS: undefined,
  //                         isNew: undefined,
  //                       }
  //                     : hs
  //                 ),
  //               }
  //             : sc
  //         ),
  //         popups: tourData!.popups.map((pop) =>
  //           pop.id === popContentData!.id
  //             ? {
  //                 ...popContentData,
  //                 type: popContentData!.image
  //                   ? "image"
  //                   : popContentData!.video
  //                   ? "video"
  //                   : "text",
  //               }
  //             : pop
  //         ),
  //       });
  //       saveTourData(newTourData as TourData);
  //     },
  //     [tourID, tourData, queryClient, currentSceneID, id, saveTourData]
  //   )

  // );
  // const formState = watch();

  useEffect(() => {
    if (tourData) {
      let temp = tourData!.scenes
        .find((one) => one.id === currentSceneID)!
        .hotspots.find((one) => one.id === id);

      const popTemp = tourData.popups.find((one) => one.id === id);

      setCurrentPop(temp);
      setCurrentPopContent(popTemp);
    }
  }, [currentSceneID, id, tourData]);

  const handlePosEdit = React.useCallback(async () => {
    //
    //
    // HOOF FORM STUFF
    // let popData = formState;
    // let popContentData = formState.content;
    // delete popData.content;
    // setValue("EDIT_POS", currentPop?.EDIT_POS);

    //

    queryClient.setQueryData(["GetTour", tourID], {
      ...tourData,
      scenes: [
        ...tourData!.scenes.map((sc) =>
          sc.id === currentSceneID
            ? {
                ...sc,
                hotspots: sc.hotspots.map((hs) =>
                  hs.id === currentPop!.id
                    ? {
                        ...currentPop,
                        EDIT_POS: currentPop?.EDIT_POS ? undefined : true,
                      }
                    : hs
                ),
              }
            : sc
        ),
      ],
      // popups: [
      //   ...tourData!.popups.map((pop) =>
      //     pop.id === popContentData?.id ? { ...popContentData } : pop
      //   ),
      // ],
    });
  }, [tourData, queryClient, currentSceneID, tourID, currentPop]);

  const handlePopupUpdate = React.useCallback(async () => {
    const newTourData = queryClient.setQueryData(["GetTour", tourID], {
      ...tourData,

      scenes: tourData?.scenes.map((sc) =>
        sc.id === currentSceneID
          ? {
              ...sc,
              hotspots: sc.hotspots.map((hs: Hotspot) =>
                hs.id === id
                  ? {
                      ...currentPop,
                      target: currentPopContent!.id,
                      EDIT_POS: undefined,
                      isNew: undefined,
                    }
                  : hs
              ),
            }
          : sc
      ),
      popups: tourData!.popups.map((pop) =>
        pop.id === currentPopContent!.id
          ? {
              ...currentPopContent,
              type: currentPopContent!.image
                ? "image"
                : currentPopContent!.video
                ? "video"
                : "text",
            }
          : pop
      ),
    });
    saveTourData(newTourData as TourData);
  }, [
    tourData,
    queryClient,
    tourID,
    currentPopContent,
    currentSceneID,
    currentPop,
    id,
    saveTourData,
  ]);

  const handleDelete = React.useCallback(async () => {
    const tempSceneSpots = tourData!.scenes
      .find((one) => one.id === currentSceneID)!
      .hotspots.filter((spot) => spot.id !== currentPop!.id);

    const tempScenePops = tourData!.popups.filter(
      (pop) => pop.id !== currentPop!.id
    );
    const newTourData = queryClient.setQueryData(["GetTour", tourID], {
      ...tourData,
      scenes: tourData!.scenes.map((scene) =>
        scene.id === currentSceneID
          ? { ...scene, hotspots: tempSceneSpots }
          : scene
      ),

      popups: tempScenePops,
    });

    saveTourData(newTourData as TourData);
    setEditingElem("scene", currentSceneID);
  }, [
    tourData,
    currentSceneID,
    currentPop,
    queryClient,
    saveTourData,
    tourID,

    setEditingElem,
  ]);

  const handleTitleChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      return queryClient.setQueryData(["GetTour", tourID], {
        ...tourData,
        popups: tourData?.popups.map((pop) =>
          pop.id === id ? { ...pop, title: e.target.value } : pop
        ),
      });
    },
    [id, queryClient, tourData, tourID]
  );

  const handleTextChange = React.useCallback(
    (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      return queryClient.setQueryData(["GetTour", tourID], {
        ...tourData,
        popups: tourData?.popups.map((pop) =>
          pop.id === id ? { ...pop, text: e.target.value } : pop
        ),
      });
    },
    [id, queryClient, tourData, tourID]
  );

  const handleImageRemove = React.useCallback(() => {
    queryClient.setQueryData(["GetTour", tourID], {
      ...tourData,
      popups: tourData!.popups.map((pop) =>
        pop.id === currentPop!.target
          ? {
              ...currentPopContent,
              type: "text",
              image: undefined,
              imageID: undefined,
              imageInfo: undefined,
            }
          : pop
      ),
    });
  }, [queryClient, tourID, tourData, currentPopContent, currentPop]);

  const handleVideoChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      queryClient.setQueryData(["GetTour", tourID], {
        ...tourData,
        popups: tourData?.popups.map((pop: Popup) =>
          pop.id === id ? { ...pop, video: e.target.value } : pop
        ),
      });
    },
    [id, queryClient, tourData, tourID]
  );

  const { setOpen } = useAssetListStore();

  const shouldConfirmDeletion = React.useMemo(() => {
    if (
      currentPopContent?.text ||
      currentPopContent?.media ||
      currentPopContent?.video
    )
      return true;
    else return false;
  }, [
    currentPopContent?.text,
    currentPopContent?.media,
    currentPopContent?.video,
  ]);

  const [confirmationPanel, setConfirmationPanel] = React.useState(false);

  const widePopup = useWidePopupStore();

  const { isTakingScreenshot, setTakingScreen, setIsOpen } =
    useWidePopupStore();

  const { resetHistory } = useGptHistoryStore();
  return (
    <div className="right-side-panel-editor">
      {/* <form
        // @ts-expect-error
        onSubmit={handleSubmit(onSubmit)}
        style={{ display: "flex", flexDirection: "column", gap: "10px" }}
      >
        <label>
          Titolo
          <input
            type="text"
            {...register("content.title")}
            placeholder="Aggiungi un titolo al popup"
          />
        </label>

        <button

          className={formState.EDIT_POS ? "active" : undefined}
          style={{
            outline: formState.EDIT_POS ? "solid 2px orange" : "none",
          }}
          onClick={handlePosEdit}
          type="button"
        >
          {formState.EDIT_POS ? "Salva" : "Modifica"} Posizione{" "}
          <EditPencil></EditPencil>
        </button>

        <label style={{ display: "flex", flexDirection: "column" }}>
          Testo
          <textarea
            {...register("content.text")}
            className="popup-editor-textarea"
            placeholder="Aggiungi del testo a questo popup"
          ></textarea>
        </label>

        <br />
        <button id="save" type="submit">
          {formState.isNew ? "Crea" : "Salva"}
        </button>
        <button type="button" id="delete">
          {formState.isNew ? "Annulla" : "Elimina"}
        </button>
      </form> */}

      {confirmationPanel && (
        <SceneDelConfirmPanel
          handleSceneDelete={() => handleDelete()}
          setIsDeletingScene={() => setConfirmationPanel(false)}
        >
          <div>{getLanguageFile("right_panel.confirm_delete_pop")}</div>
        </SceneDelConfirmPanel>
      )}
      <div>
        {currentPopContent && tourData && (
          <>
            <form
              style={{ display: "flex", flexDirection: "column", gap: "10px" }}
              onSubmit={(e) => {
                setTakingScreen(false);
                setIsOpen(false);
                resetHistory();
                e.preventDefault();
                handlePopupUpdate();
              }}
            >
              <label>
                {getLanguageFile("right_panel.title")}
                <input
                  disabled={isTakingScreenshot}
                  maxLength={32}
                  required
                  type="text"
                  placeholder={getLanguageFile(
                    "right_panel.title_placeholder_pop"
                  )}
                  style={{
                    color: "#474747",
                    fontWeight: 600,
                  }}
                  value={currentPopContent?.title}
                  onChange={(e) => {
                    setCurrentPopContent({
                      ...currentPopContent,
                      title: e.target.value,
                    } as Popup);
                    handleTitleChange(e);
                  }}
                ></input>
              </label>
              {currentPop && (
                <button
                  className={currentPop.EDIT_POS ? "active" : undefined}
                  onClick={handlePosEdit}
                  id="edit"
                  type="button"
                  disabled={isTakingScreenshot}
                >
                  {currentPop?.EDIT_POS ? (
                    getLanguageFile("right_panel.save_position")
                  ) : (
                    <>
                      {getLanguageFile("right_panel.edit_position")}
                      <EditPencil />
                    </>
                  )}
                </button>
              )}

              <div className="category-divider">
                <h4>{getLanguageFile("right_panel.content")}</h4>
                <hr />
              </div>
              <label className="form">
                {getLanguageFile("right_panel.text")}
                <textarea
                  className="popup-editor-textarea"
                  placeholder={getLanguageFile("right_panel.text_placeholder")}
                  value={currentPopContent?.text || ""}
                  onChange={(e) => {
                    setCurrentPopContent({
                      ...currentPopContent,
                      text: e.target.value,
                    } as Popup);
                    handleTextChange(e);
                  }}
                ></textarea>
              </label>
              {OPENAIENABLED && (
                <div>
                  <button
                    id="openai"
                    type="button"
                    onClick={() => {
                      widePopup.setIsOpen(
                        true,
                        currentPopContent?.id as string
                      );
                    }}
                    disabled={isTakingScreenshot}
                  >
                    {/* <OpenAiLogo width={20} height={20} stroke="#fff" /> */}
                    OpenAi
                  </button>
                </div>
              )}
              <label>
                {getLanguageFile("right_panel.picture")}
                <div
                  style={{
                    display: "flex",
                  }}
                >
                  <FileSelectorButton
                    disabled={isTakingScreenshot || !!currentPopContent.video}
                    id="image"
                    onClickFunction={() => setOpen(2)}
                  >
                    {images?.find(
                      (one) =>
                        one.assetKeyFull ===
                        tourData.popups.find((one) => one.id === id)?.image
                    )?.assetDescription ||
                      getLanguageFile("right_panel.picture_placeholder")}
                  </FileSelectorButton>

                  {currentPopContent?.image && (
                    <button
                      disabled={isTakingScreenshot}
                      type="button"
                      style={{
                        minWidth: "0",
                        fontWeight: "900",
                        border: "none",
                      }}
                      onClick={handleImageRemove}
                    >
                      ✖
                    </button>
                  )}
                </div>
              </label>

              <label>
                {getLanguageFile("right_panel.video")}
                <div className="url-wrapper">
                  <LinkInputIcon
                    width="1rem"
                    height="1rem"
                    style={{
                      position: "absolute",
                      top: "50%",
                      right: "10px",
                      transform: "translateY(-50%)",
                    }}
                  />

                  <input
                    type="url"
                    id="url"
                    placeholder={getLanguageFile("right_panel.url_placeholder")}
                    disabled={
                      currentPopContent?.image || isTakingScreenshot
                        ? true
                        : false
                    }
                    defaultValue={
                      tourData.popups.find((one) => one.id === id)?.video
                    }
                    onChange={handleVideoChange}
                  />
                </div>
              </label>
              <div style={{ display: "flex" }}>
                <button
                  type="submit"
                  id="save"
                  disabled={isSavingTour || isTakingScreenshot}
                  style={{ flex: 1 }}
                >
                  {currentPop?.isNew
                    ? getLanguageFile("right_panel.create_pop")
                    : isSavingTour
                    ? getLanguageFile("generics.saving")
                    : getLanguageFile("generics.save")}
                </button>

                <button
                  id="delete"
                  onClick={() => {
                    setTakingScreen(false);
                    setIsOpen(false);
                    resetHistory();
                    if (shouldConfirmDeletion) setConfirmationPanel(true);
                    else handleDelete();
                  }}
                  type="button"
                  disabled={isSavingTour}
                  style={{ flex: 1 }}
                >
                  {currentPop?.isNew ? (
                    getLanguageFile("generics.cancel")
                  ) : (
                    <>
                      {getLanguageFile("generics.delete")} <Trashbin />
                    </>
                  )}
                </button>
              </div>
            </form>
          </>
        )}
      </div>

      <OtherHotspots
        disabled={isTakingScreenshot}
        currentHotspot={currentPop!}
        icon={<PopupExpIcon width="1em" height="1em" fill="#fff" />}
        tourData={tourData!}
        type="popup"
      ></OtherHotspots>
    </div>
  );
}

export default PopupEditing;
